import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import './Legal.css';

function Terms() {
  const { i18n } = useTranslation();
  const [showLangMenu, setShowLangMenu] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // localStorage'dan dili oku ve i18n'e uygula
    const savedLanguage = localStorage.getItem('rux_language');
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  const lang = i18n.language === 'tr' ? 'tr' : 'en';

  const changeLanguage = (newLang) => {
    i18n.changeLanguage(newLang);
    localStorage.setItem('rux_language', newLang);
    setShowLangMenu(false);
  };

  return (
    <div className="legal-page">
      {/* Navbar */}
      <header className="legal-header">
        <div className="legal-container">
          <nav className="legal-navbar">
            <Link to="/" className="legal-logo">
              <img src="/images/ruxLogo-40.png" className="logo-image" alt="RUX Engine" />
              <h3 className="logo-text">RuX Engine</h3>
            </Link>
            <div className="legal-nav-links">
              <Link to="/">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
              <Link to="/terms" className="active">{lang === 'tr' ? 'Kullanım Koşulları' : 'Terms'}</Link>
              <Link to="/privacy">{lang === 'tr' ? 'Gizlilik' : 'Privacy'}</Link>
              
              {/* Dil Seçimi */}
              <div className="language-selector">
                <button 
                  className="lang-btn"
                  onClick={() => setShowLangMenu(!showLangMenu)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 12px',
                    border: '1px solid rgba(255,255,255,0.2)',
                    borderRadius: '6px',
                    color: '#000',
                    cursor: 'pointer',
                    fontSize: '14px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.4)'}
                  onMouseLeave={(e) => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'}
                >
                  <Globe size={16} />
                  <span>{lang === 'tr' ? 'TR' : 'EN'}</span>
                </button>
                
                {showLangMenu && (
                  <div 
                    className="lang-menu"
                    style={{
                      position: 'absolute',
                      top: '100%',
                      right: '0',
                      marginTop: '8px',
                      background: 'rgba(30, 30, 40, 0.95)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                      zIndex: 1000,
                      minWidth: '120px'
                    }}
                  >
                    <button
                      onClick={() => changeLanguage('tr')}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: lang === 'tr' ? 'rgba(99, 102, 241, 0.2)' : 'transparent',
                        border: 'none',
                        color: 'white',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (lang !== 'tr') e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      }}
                      onMouseLeave={(e) => {
                        if (lang !== 'tr') e.currentTarget.style.background = 'transparent';
                      }}
                    >
                      🇹🇷 Türkçe
                    </button>
                    <button
                      onClick={() => changeLanguage('en')}
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        background: lang === 'en' ? 'rgba(99, 102, 241, 0.2)' : 'transparent',
                        border: 'none',
                        color: 'white',
                        cursor: 'pointer',
                        textAlign: 'left',
                        fontSize: '14px',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        if (lang !== 'en') e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                      }}
                      onMouseLeave={(e) => {
                        if (lang !== 'en') e.currentTarget.style.background = 'transparent';
                      }}
                    >
                      🇬🇧 English
                    </button>
                  </div>
                )}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Content */}
      <div className="legal-content-wrapper">
        <div className="legal-content">
          {lang === 'tr' ? <TermsTR /> : <TermsEN />}
        </div>
      </div>

      {/* Footer */}
      <footer className="legal-footer">
        <div className="legal-container">
          <div className="footer-content">
            <div className="footer-col">
              <h4>RUX Engine</h4>
              <p>{lang === 'tr' ? 'Web site izleme hizmeti' : 'Website monitoring service'}</p>
            </div>
            <div className="footer-col">
              <h4>{lang === 'tr' ? 'Yasal' : 'Legal'}</h4>
              <Link to="/terms">{lang === 'tr' ? 'Kullanım Koşulları' : 'Terms of Service'}</Link>
              <Link to="/privacy">{lang === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy'}</Link>
            </div>
            <div className="footer-col">
              <h4>{lang === 'tr' ? 'İletişim' : 'Contact'}</h4>
              <p>support@ruxengine.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} RUX Engine. {lang === 'tr' ? 'Tüm hakları saklıdır.' : 'All rights reserved.'}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Türkçe İçerik
function TermsTR() {
  return (
    <>
      <h1>KULLANIM KOŞULLARI</h1>
      <p><strong>Son Güncelleme:</strong> 26 Şubat 2026</p>

      <p>RUX Engine web sitesi izleme hizmetini ("Hizmet") kullanarak, aşağıdaki Kullanım Koşulları'nı ("Şartlar") kabul etmiş sayılırsınız. Lütfen bu belgeyi dikkatlice okuyunuz. Şartları kabul etmiyorsanız, Hizmeti kullanmamalısınız.</p>

      <hr />

      <h2>1. HİZMETİN TANIMI VE KAPSAMI</h2>
      <p>RUX Engine, kullanıcıların web sitelerini otomatik olarak izler ve aşağıdaki hizmetleri sunar:</p>
      <ul>
        <li><strong>Uptime İzleme:</strong> Web sitelerinin erişilebilirliğini dakikalık aralıklarla kontrol eder</li>
        <li><strong>Hata Tespiti:</strong> HTTP hata kodlarını (4xx, 5xx) tespit eder</li>
        <li><strong>Bildirim Sistemi:</strong> Hata durumlarında e-posta ile anında bildirim gönderir</li>
        <li><strong>Ekran Görüntüsü:</strong> Web sitesinin anlık görünümünü kaydeder (maksimum 7 gün saklanır)</li>
        <li><strong>İstatistikler:</strong> Uptime/downtime oranları ve geçmiş verilere erişim</li>
      </ul>

      <h3>Kontrol Sıklığı</h3>
      <p>Web siteleri <strong>dakikada bir (1 dakika)</strong> kontrol edilir. Bu süre, sistem yoğunluğuna bağlı olarak ±10 saniye değişkenlik gösterebilir.</p>

      <hr />

      <h2>2. KULLANICI KAYDI VE HESAP YÖNETİMİ</h2>
      <h3>Hesap Oluşturma</h3>
      <ul>
        <li>Kullanıcılar <strong>ad, soyad ve e-posta</strong> ile kayıt olabilir</li>
        <li>18 yaşından büyük olmak zorunludur</li>
        <li>Kayıt sırasında verilen bilgilerin doğru ve güncel olması kullanıcının sorumluluğundadır</li>
      </ul>

      <h3>Fatura Profili</h3>
      <ul>
        <li>Ödeme yapabilmek için kullanıcının <strong>fatura profilini</strong> eksiksiz doldurması zorunludur</li>
        <li>Fatura profili şu bilgileri içerir: <strong>ad, soyad, e-posta, telefon numarası (ülke kodu dahil), ülke, şehir, adres, posta kodu</strong></li>
        <li>Türkiye'deki bireysel kullanıcılar için <strong>TC Kimlik Numarası</strong> zorunludur</li>
        <li>Kurumsal kullanıcılar için <strong>şirket adı ve vergi bilgileri</strong> zorunludur</li>
        <li>Bu bilgiler Türk vergi mevzuatı (VUK) kapsamında fatura düzenleme yükümlülüğü gereği toplanır</li>
        <li>Telefon numarası ödeme doğrulama amacıyla <strong>PayTR ödeme sağlayıcısına</strong> iletilir</li>
      </ul>

      <h3>Hesap Güvenliği</h3>
      <ul>
        <li>Kullanıcı, hesap şifresini gizli tutmakla yükümlüdür</li>
        <li>Hesap erişiminin üçüncü şahıslarla paylaşılması yasaktır</li>
        <li>Şüpheli aktivite tespit edilirse derhal support@ruxengine.com adresine bildirilmelidir</li>
      </ul>

      <hr />

      <h2>3. ÜCRETSİZ DENEME SÜRESİ</h2>
      
      <h3>3.1. Deneme Koşulları</h3>
      <ul>
        <li>Her domain için <strong>bir kez</strong> ücretsiz deneme hakkı vardır</li>
        <li>Her kullanıcı <strong>maksimum 2 domain</strong> için ücretsiz deneme kullanabilir</li>
        <li>Deneme süresi: <strong>7 gün</strong></li>
        <li>Deneme sırasında <strong>kredi kartı bilgisi GEREKMEZ</strong></li>
        <li>Tüm özellikler deneme süresince kullanılabilir</li>
      </ul>

      <h3>3.2. Deneme Süresi Sonunda</h3>
      <ul>
        <li>Süre bitiminde kullanıcı ödeme yapabilir veya hizmeti durdurabilir</li>
        <li><strong>Otomatik ödeme ASLA tahsil edilmez</strong></li>
        <li>Ödeme yapılmazsa domain monitoring otomatik olarak durdurulur</li>
        <li>Domain kaydı sistemde kalır, sadece monitoring pasif duruma geçer</li>
      </ul>

      <h3>3.3. Kötüye Kullanım Önlemi</h3>
      <ul>
        <li>Aynı domain bir kez deneme kullandıktan sonra tekrar kullanamaz</li>
        <li>Kullanıcı hesabını silip yeniden oluştursa bile trial limiti korunur</li>
        <li>Email bazlı kontrol: Aynı email ile maksimum 2 trial hakkı</li>
        <li>Domain bazlı kontrol: Aynı domain bir kez trial kullanabilir</li>
      </ul>

      <hr />

      <h2>4. FİYATLANDIRMA VE ÖDEME</h2>

      <h3>4.1. Fiyatlandırma Modeli</h3>
      <ul>
        <li><strong>Dinamik Fiyatlandırma:</strong> Aylık birim fiyat site yöneticisi tarafından belirlenir</li>
        <li><strong>Süre Seçimi:</strong> Kullanıcı 1-12 ay arası istediği süreyi seçebilir</li>
        <li><strong>Hesaplama:</strong> Toplam ücret = Aylık fiyat × Seçilen ay sayısı</li>
        <li><strong>Para Birimi:</strong> USD veya TRY seçilebilir</li>
        <li><strong>Döviz Kuru:</strong> TRY fiyatları, yönetici tarafından belirlenen kur çarpanı ile hesaplanır</li>
      </ul>
      
      <p><strong>Örnek:</strong> Aylık fiyat $5.00 ise ve kullanıcı 3 ay seçerse → Toplam: $15.00</p>

      <h3>4.2. Ücretsiz Deneme</h3>
      <ul>
        <li>Her domain için <strong>bir kez</strong> ücretsiz deneme hakkı vardır</li>
        <li>Her kullanıcı <strong>maksimum 2 domain</strong> için ücretsiz deneme kullanabilir</li>
        <li>Deneme süresi: <strong>7 gün</strong></li>
        <li>Deneme süresi bitiminde hizmet otomatik olarak durdurulur</li>
        <li><strong>Kötüye kullanım önlemi:</strong> Aynı domain veya kullanıcı, hesap silip tekrar oluştursa bile yeni deneme hakkı alamaz</li>
      </ul>

      <h3>4.3. Ödeme Koşulları</h3>
      <ul>
        <li>Ödeme yapabilmek için <strong>fatura profilinin</strong> eksiksiz doldurulması zorunludur</li>
        <li>Ödemeler <strong>peşin</strong> alınır (seçilen süre için toplam tutar)</li>
        <li>Kredi kartı bilgileri <strong>RUX Engine sisteminde ASLA saklanmaz</strong></li>
        <li>Ödemeler güvenli ödeme sağlayıcısı (PayTR) üzerinden işlenir</li>
        <li>Ödeme sırasında ad, soyad, e-posta, telefon ve adres bilgileri PayTR'ye iletilir</li>
        <li>Her ödeme için kart bilgilerini yeniden girmeniz gerekir</li>
        <li><strong>Otomatik yenileme YOKTUR</strong> - Süre bitiminde manuel ödeme gerekir</li>
      </ul>

      <h3>4.4. İptal ve İade Politikası</h3>
      <ul>
        <li><strong>Ücretsiz deneme sırasında:</strong> İstediğiniz zaman iptal edebilirsiniz (ödeme yapılmadığı için iade söz konusu değildir)</li>
        <li><strong>Ödeme yapıldıktan sonra:</strong> Yapılan ödemeler <strong>kesindir</strong>, iptal ve iade <strong>YAPILMAZ</strong></li>
        <li><strong>Hizmet kesintisi:</strong> RUX Engine kaynaklı kesinti durumunda, kesinti süresi kadar ek süre tanınır</li>
        <li><strong>Hesap silme:</strong> Hesap silinse bile ödenen tutarlar <strong>iade edilmez</strong></li>
      </ul>
      
      <p style={{ color: '#cc0000', fontWeight: 'bold' }}>
        ⚠️ ÖNEMLİ: Ödeme yaptıktan sonra cayma hakkı YOKTUR. Lütfen satın almadan önce hizmet koşullarını dikkatlice okuyun.
      </p>

      <hr />

      <h2>5. KULLANIM KURALLARI VE KISITLAMALAR</h2>

      <h3>İzin Verilen Kullanım</h3>
      <ul>
        <li>Kullanıcı, yalnızca <strong>kendine ait veya yetkili olduğu</strong> web sitelerini izleyebilir</li>
      </ul>

      <h3>Yasak Davranışlar</h3>
      <p>Aşağıdaki eylemler kesinlikle yasaktır ve hesap kapatma sebebidir:</p>
      <ul>
        <li><strong>Başkasına ait web sitelerini izinsiz izleme</strong></li>
        <li>Sisteme zarar verici yazılım, bot veya script kullanma</li>
        <li>Hizmetin altyapısına DDoS, brute-force veya benzeri saldırılar yapma</li>
        <li>Diğer kullanıcıların hesaplarına izinsiz erişim sağlama</li>
        <li>Yasadışı, zararlı, tehdit edici, taciz edici içerik barındıran siteleri izleme</li>
        <li>Hizmeti ters mühendislik (reverse engineering) ile kopyalama</li>
      </ul>

      <hr />

      <h2>6. HİZMET GARANTİSİ VE SINIRLAMALAR</h2>

      <h3>Uptime Garantisi</h3>
      <ul>
        <li>RUX Engine, <strong>%99.9 uptime</strong> hedefler ancak garanti etmez</li>
        <li>Sistem bakımları önceden duyurulur</li>
        <li>Beklenmedik kesintiler için <strong>sorumluluk kabul edilmez</strong></li>
      </ul>

      <h3>Sorumluluk Reddi</h3>
      <ul>
        <li>RUX Engine, kullanıcının web sitesinde meydana gelen hataların tespitini sağlar ancak <strong>hatalardan sorumlu değildir</strong></li>
        <li>Bildirim gecikmesi veya alınamaması durumunda RUX Engine sorumlu tutulamaz</li>
        <li>Ekran görüntülerinin hukuki delil olarak kullanılması kullanıcının kendi takdirindedir</li>
      </ul>

      <h3>Hizmet Kesintileri</h3>
      <p>RUX Engine aşağıdaki durumlarda hizmet sunmayabilir:</p>
      <ul>
        <li>Planlı sistem güncellemeleri (önceden duyurulur)</li>
        <li>Doğal afet, savaş, terör olayları (force majeure)</li>
        <li>İnternet servis sağlayıcı kesintileri</li>
        <li>Üçüncü taraf hizmet sağlayıcı arızaları</li>
      </ul>

      <hr />

      <h2>7. EKSİK VERİ KORUMASI VE GİZLİLİK</h2>
      <ul>
        <li>Kullanıcı verileri <strong>KVKK ve GDPR</strong> uyarınca işlenir</li>
        <li>Detaylı bilgi için <Link to="/privacy" style={{ color: '#6366f1' }}>Gizlilik Politikası</Link> sayfasını inceleyiniz</li>
        <li>Ekran görüntüleri <strong>maksimum 7 gün</strong> saklanır ve otomatik silinir</li>
        <li>Kredi kartı bilgileri <strong>hiçbir şekilde saklanmaz</strong></li>
        <li>Fatura profili bilgileri (ad, soyad, adres, telefon, TC Kimlik No / vergi bilgileri) yasal zorunluluk gereği <strong>5 yıl</strong> saklanır</li>
        <li>Telefon numarası ödeme doğrulama amacıyla PayTR'ye iletilir ve PayTR'nin gizlilik politikasına tabidir</li>
      </ul>

      <hr />

      <h2>8. FİKRİ MÜLKİYET HAKLARI</h2>

      <h3>Telif Hakları</h3>
      <ul>
        <li>RUX Engine markası, logosu, yazılımı ve içeriği <strong>telif hakkı koruması</strong> altındadır</li>
        <li>Kullanıcılar, sistemin kaynak kodunu kopyalayamaz, dağıtamaz veya satamaz</li>
      </ul>

      <h3>Kullanıcı İçerikleri</h3>
      <ul>
        <li>Kullanıcı, eklediği web sitelerinin URL'leri üzerinde tüm haklara sahip olduğunu beyan eder</li>
        <li>RUX Engine, kullanıcının ekran görüntülerini saklar ancak sahipliğini iddia etmez</li>
      </ul>

      <hr />

      <h2>9. HESAP KAPATMA VE FESİH</h2>

      <h3>9.1. Kullanıcı Tarafından Hesap Silme</h3>
      <ul>
        <li>Kullanıcı istediği zaman Settings sayfasından hesabını silebilir</li>
        <li>Hesap silme işlemi <strong>geri alınamaz</strong></li>
        <li>Kalan hizmet süresi için <strong>iade yapılmaz</strong></li>
      </ul>

      <h3>9.2. Silinen Veriler (Hemen)</h3>
      <ul>
        <li>Kişisel bilgileriniz (ad, email, şifre)</li>
        <li>Tüm domain kayıtlarınız</li>
        <li>Domain kontrol geçmişiniz</li>
        <li>Ekran görüntüleriniz</li>
      </ul>

      <h3>9.3. Korunan Veriler (Yasal Zorunluluk)</h3>
      <ul>
        <li><strong>Fatura kayıtları:</strong> 5 yıl saklanır (VUK Madde 253 - vergi mevzuatı)</li>
        <li><strong>Fatura profili bilgileri:</strong> Ad, soyad, adres, telefon, TC Kimlik No / vergi bilgileri fatura kayıtlarıyla birlikte 5 yıl saklanır</li>
        <li><strong>Hesap silme logları:</strong> 5 yıl saklanır (KVKK/GDPR denetim gereksinimi)</li>
        <li><strong>Trial kullanım kayıtları:</strong> Kalıcı saklanır (kötüye kullanım önlemi)</li>
      </ul>

      <h3>9.4. RUX Engine Tarafından Hesap Kapatma</h3>
      <p>RUX Engine, aşağıdaki durumlarda kullanıcı hesabını kapatma hakkını saklı tutar:</p>
      <ul>
        <li>Kullanım şartlarının ihlali</li>
        <li>Yasadışı faaliyetler</li>
        <li>Ödeme yapılmaması (süre bitiminde monitoring otomatik durdurulur)</li>
        <li>Sisteme zarar verici davranışlar</li>
        <li>Kötüye kullanım tespiti</li>
      </ul>

      <hr />

      <h2>10. UYUŞMAZLIK ÇÖZÜMÜ VE YARGI YERİ</h2>

      <h3>Yasal Düzenlemeler</h3>
      <ul>
        <li>Bu sözleşme <strong>Türkiye Cumhuriyeti Kanunları</strong>'na tabidir</li>
        <li>Tüketici hakları <strong>6502 sayılı Tüketicinin Korunması Hakkında Kanun</strong> kapsamındadır</li>
      </ul>

      <h3>Yargı Yeri</h3>
      <ul>
        <li>Herhangi bir uyuşmazlık halinde <strong>Türkiye mahkemeleri</strong> yetkilidir</li>
        <li>Tüketici işlemleri için <strong>Tüketici Hakem Heyetleri</strong> ve <strong>Tüketici Mahkemeleri</strong> yetkilidir</li>
      </ul>

      <hr />

      <h2>11. KOŞULLARDA DEĞİŞİKLİK</h2>
      <ul>
        <li>RUX Engine, bu Kullanım Koşulları'nı <strong>istediği zaman değiştirebilir</strong></li>
        <li>Değişiklikler kullanıcılara <strong>e-posta ile bildirilir</strong></li>
        <li>Değişiklik sonrası hizmeti kullanmaya devam etmek, yeni şartları kabul ettiğiniz anlamına gelir</li>
        <li>Kabul etmiyorsanız hesabınızı kapatma hakkına sahipsiniz</li>
      </ul>

      <hr />

      <h2>12. İLETİŞİM</h2>
      <p>Kullanım Koşulları ile ilgili sorularınız için:</p>
      <ul>
        <li><strong>E-posta:</strong> support@ruxengine.com</li>
        <li><strong>Website:</strong> ruxengine.com</li>
      </ul>

      <hr />

      <p><strong>Yürürlük Tarihi:</strong> 26 Şubat 2026</p>
      <p><em>Bu belgeyi kabul ederek, yukarıdaki tüm şartları okuduğunuzu ve kabul ettiğinizi beyan etmiş olursunuz.</em></p>
    </>
  );
}

// English Content
function TermsEN() {
  return (
    <>
      <h1>TERMS OF SERVICE</h1>
      <p><strong>Last Updated:</strong> February 26, 2026</p>

      <p>By using the RUX Engine website monitoring service ("Service"), you agree to the following Terms of Service ("Terms"). Please read this document carefully. If you do not agree to these Terms, you should not use the Service.</p>

      <hr />

      <h2>1. SERVICE DEFINITION AND SCOPE</h2>
      <p>RUX Engine automatically monitors users' websites and provides the following services:</p>
      <ul>
        <li><strong>Uptime Monitoring:</strong> Checks website accessibility at minute intervals</li>
        <li><strong>Error Detection:</strong> Detects HTTP error codes (4xx, 5xx)</li>
        <li><strong>Notification System:</strong> Sends instant email notifications in case of errors</li>
        <li><strong>Screenshots:</strong> Records instant views of websites (stored for maximum 7 days)</li>
        <li><strong>Statistics:</strong> Access to uptime/downtime ratios and historical data</li>
      </ul>

      <h3>Check Frequency</h3>
      <p>Websites are checked <strong>once per minute (1 minute)</strong>. This period may vary by ±10 seconds depending on system load.</p>

      <hr />

      <h2>2. USER REGISTRATION AND ACCOUNT MANAGEMENT</h2>
      <h3>Account Creation</h3>
      <ul>
        <li>Users can register with <strong>name, surname, and email</strong></li>
        <li>Must be over 18 years old</li>
        <li>It is the user's responsibility to ensure the information provided during registration is accurate and up-to-date</li>
      </ul>

      <h3>Billing Profile</h3>
      <ul>
        <li>Users must complete their <strong>billing profile</strong> in full before making any payment</li>
        <li>Billing profile includes: <strong>first name, last name, email, phone number (with country code), country, city, address, postal code</strong></li>
        <li>For individual users in Turkey, <strong>Turkish National ID Number (TC Kimlik No)</strong> is required</li>
        <li>For company users, <strong>company name and tax information</strong> are required</li>
        <li>This information is collected under Turkish tax legislation (Tax Procedure Law) for invoicing obligations</li>
        <li>Phone number is transmitted to <strong>PayTR payment provider</strong> for payment verification</li>
      </ul>

      <h3>Account Security</h3>
      <ul>
        <li>User is obligated to keep account password confidential</li>
        <li>Sharing account access with third parties is prohibited</li>
        <li>Suspicious activity should be reported immediately to support@ruxengine.com</li>
      </ul>

      <hr />

      <h2>3. FREE TRIAL PERIOD</h2>
      
      <h3>3.1. Trial Conditions</h3>
      <ul>
        <li>Each domain has <strong>one-time</strong> free trial right</li>
        <li>Each user can use free trial for <strong>maximum 2 domains</strong></li>
        <li>Trial duration: <strong>7 days</strong></li>
        <li><strong>NO credit card information required</strong> during trial</li>
        <li>All features are available during trial period</li>
      </ul>

      <h3>3.2. After Trial Period</h3>
      <ul>
        <li>User can make payment or stop service when period ends</li>
        <li><strong>NO automatic payment is EVER charged</strong></li>
        <li>If no payment is made, domain monitoring is automatically stopped</li>
        <li>Domain record remains in system, only monitoring becomes passive</li>
      </ul>

      <h3>3.3. Abuse Prevention</h3>
      <ul>
        <li>Same domain cannot use trial again after first use</li>
        <li>Trial limit is preserved even if user deletes and recreates account</li>
        <li>Email-based control: Maximum 2 trials per email</li>
        <li>Domain-based control: Each domain can use trial once</li>
      </ul>

      <hr />

      <h2>4. PRICING AND PAYMENT</h2>

      <h3>4.1. Pricing Model</h3>
      <ul>
        <li><strong>Dynamic Pricing:</strong> Monthly unit price is set via admin</li>
        <li><strong>Duration Selection:</strong> Users can select any duration between 1-12 months</li>
        <li><strong>Calculation:</strong> Total fee = Monthly price × Selected months</li>
        <li><strong>Currency:</strong> USD or TRY can be selected</li>
        <li><strong>Exchange Rate:</strong> TRY prices are calculated using the exchange rate multiplier set by admin</li>
      </ul>
      
      <p><strong>Example:</strong> If monthly price is $5.00 and user selects 3 months → Total: $15.00</p>

      <h3>4.2. Free Trial</h3>
      <ul>
        <li>Each domain has <strong>one-time</strong> free trial right</li>
        <li>Each user can use free trial for <strong>maximum 2 domains</strong></li>
        <li>Trial duration: <strong>7 days</strong></li>
        <li>Service automatically stops when trial period ends</li>
        <li><strong>Abuse prevention:</strong> Same domain or user cannot get new trial even after account deletion and recreation</li>
      </ul>

      <h3>4.3. Payment Terms</h3>
      <ul>
        <li>A fully completed <strong>billing profile</strong> is required before making any payment</li>
        <li>Payments are made <strong>upfront</strong> (total amount for selected duration)</li>
        <li>Credit card information is <strong>NEVER stored in RUX Engine systems</strong></li>
        <li>Payments are processed through secure payment provider (PayTR)</li>
        <li>During payment, your name, surname, email, phone number and address information are transmitted to PayTR</li>
        <li>You must re-enter card information for each payment</li>
        <li><strong>NO automatic renewal</strong> - Manual payment required after period ends</li>
      </ul>

      <h3>4.4. Cancellation and Refund Policy</h3>
      <ul>
        <li><strong>During free trial:</strong> You can cancel anytime (no refund applicable as no payment made)</li>
        <li><strong>After payment:</strong> Payments made are <strong>final</strong>, cancellation and refund <strong>NOT AVAILABLE</strong></li>
        <li><strong>Service interruption:</strong> In case of RUX Engine-caused interruption, additional time equal to interruption duration will be granted</li>
        <li><strong>Account deletion:</strong> Paid amounts are <strong>non-refundable</strong> even if account is deleted</li>
      </ul>
      
      <p style={{ color: '#cc0000', fontWeight: 'bold' }}>
        ⚠️ IMPORTANT: NO right of withdrawal after payment. Please read service terms carefully before purchase.
      </p>

      <hr />

      <h2>5. USAGE RULES AND RESTRICTIONS</h2>

      <h3>Permitted Use</h3>
      <ul>
        <li>User may only monitor websites they <strong>own or are authorized to monitor</strong></li>
      </ul>

      <h3>Prohibited Actions</h3>
      <p>The following actions are strictly prohibited and grounds for account closure:</p>
      <ul>
        <li><strong>Monitoring websites owned by others without permission</strong></li>
        <li>Using harmful software, bots, or scripts against the system</li>
        <li>Conducting DDoS, brute-force, or similar attacks on service infrastructure</li>
        <li>Unauthorized access to other users' accounts</li>
        <li>Monitoring sites hosting illegal, harmful, threatening, or harassing content</li>
        <li>Copying the service through reverse engineering</li>
      </ul>

      <hr />

      <h2>6. SERVICE GUARANTEE AND LIMITATIONS</h2>

      <h3>Uptime Guarantee</h3>
      <ul>
        <li>RUX Engine targets <strong>99.9% uptime</strong> but does not guarantee it</li>
        <li>System maintenance is announced in advance</li>
        <li><strong>No liability</strong> accepted for unexpected interruptions</li>
      </ul>

      <h3>Disclaimer</h3>
      <ul>
        <li>RUX Engine provides detection of errors on user's website but is <strong>not responsible for the errors</strong></li>
        <li>RUX Engine cannot be held liable for notification delays or failures</li>
        <li>Use of screenshots as legal evidence is at user's discretion</li>
      </ul>

      <h3>Service Interruptions</h3>
      <p>RUX Engine may not provide service in the following situations:</p>
      <ul>
        <li>Planned system updates (announced in advance)</li>
        <li>Natural disasters, war, terrorist incidents (force majeure)</li>
        <li>Internet service provider outages</li>
        <li>Third-party service provider failures</li>
      </ul>

      <hr />

      <h2>7. DATA PROTECTION AND PRIVACY</h2>
      <ul>
        <li>User data is processed in accordance with <strong>KVKK and GDPR</strong></li>
        <li>For detailed information, please review the <Link to="/privacy" style={{ color: '#6366f1' }}>Privacy Policy</Link> page</li>
        <li>Screenshots are stored for <strong>maximum 7 days</strong> and automatically deleted</li>
        <li>Credit card information is <strong>never stored</strong></li>
        <li>Billing profile information (name, surname, address, phone, National ID / tax information) is retained for <strong>5 years</strong> as required by law</li>
        <li>Phone number is transmitted to PayTR for payment verification and is subject to PayTR's privacy policy</li>
      </ul>

      <hr />

      <h2>8. INTELLECTUAL PROPERTY RIGHTS</h2>

      <h3>Copyrights</h3>
      <ul>
        <li>RUX Engine brand, logo, software, and content are protected by <strong>copyright</strong></li>
        <li>Users may not copy, distribute, or sell the system's source code</li>
      </ul>

      <h3>User Content</h3>
      <ul>
        <li>User declares they have all rights to the URLs of added websites</li>
        <li>RUX Engine stores user screenshots but does not claim ownership</li>
      </ul>

      <hr />

      <h2>9. ACCOUNT CLOSURE AND TERMINATION</h2>

      <h3>9.1. Account Deletion by User</h3>
      <ul>
        <li>User can delete their account from Settings page at any time</li>
        <li>Account deletion is <strong>irreversible</strong></li>
        <li><strong>No refund</strong> for remaining service period</li>
      </ul>

      <h3>9.2. Deleted Data (Immediately)</h3>
      <ul>
        <li>Your personal information (name, email, password)</li>
        <li>All your domain records</li>
        <li>Your domain check history</li>
        <li>Your screenshots</li>
      </ul>

      <h3>9.3. Retained Data (Legal Requirement)</h3>
      <ul>
        <li><strong>Invoice records:</strong> Retained for 5 years (Tax Law Article 253)</li>
        <li><strong>Billing profile information:</strong> Name, surname, address, phone, National ID / tax information retained alongside invoice records for 5 years</li>
        <li><strong>Account deletion logs:</strong> Retained for 5 years (KVKK/GDPR audit requirement)</li>
        <li><strong>Trial usage records:</strong> Retained permanently (abuse prevention)</li>
      </ul>

      <h3>9.4. Account Closure by RUX Engine</h3>
      <p>RUX Engine reserves the right to close user account in the following cases:</p>
      <ul>
        <li>Violation of terms of use</li>
        <li>Illegal activities</li>
        <li>Non-payment (monitoring automatically stops at end of period)</li>
        <li>System-damaging behavior</li>
        <li>Abuse detection</li>
      </ul>

      <hr />

      <h2>10. DISPUTE RESOLUTION AND JURISDICTION</h2>

      <h3>Legal Regulations</h3>
      <ul>
        <li>This agreement is subject to <strong>Laws of the Republic of Turkey</strong></li>
        <li>Consumer rights are under <strong>Law No. 6502 on Consumer Protection</strong></li>
      </ul>

      <h3>Jurisdiction</h3>
      <ul>
        <li>In case of any dispute, <strong>Turkish courts</strong> have jurisdiction</li>
        <li>For consumer transactions, <strong>Consumer Arbitration Committees</strong> and <strong>Consumer Courts</strong> have jurisdiction</li>
      </ul>

      <hr />

      <h2>11. CHANGES TO TERMS</h2>
      <ul>
        <li>RUX Engine may <strong>change these Terms of Service at any time</strong></li>
        <li>Changes will be <strong>notified to users via email</strong></li>
        <li>Continuing to use the service after changes means you accept the new terms</li>
        <li>If you do not accept, you have the right to close your account</li>
      </ul>

      <hr />

      <h2>12. CONTACT</h2>
      <p>For questions regarding Terms of Service:</p>
      <ul>
        <li><strong>Email:</strong> support@ruxengine.com</li>
        <li><strong>Website:</strong> ruxengine.com</li>
      </ul>

      <hr />

      <p><strong>Effective Date:</strong> February 26, 2026</p>
      <p><em>By accepting this document, you declare that you have read and accepted all the above terms.</em></p>
    </>
  );
}

export default Terms;
